import clsx from "clsx";
import { getGatewayScoreColorAndDesc } from "../../utils";

export const ScoreCard = ({ title, score }) => {
  const { color: gatewayScoreBgColor, desc: gatewayScoreDesc } =
    getGatewayScoreColorAndDesc(score);

  return (
    <div
      className={clsx(
        "flex flex-1 justify-center items-center xl:items-end rounded-[6px] px-1 py-2 gap-1",
        gatewayScoreBgColor && `bg-[${gatewayScoreBgColor}]`,
      )}
    >
      <span className=" text-[12px] font-normal leading-[18px] text-[#FFFFFF88]">
        {title}:
      </span>
      <span className=" text-[16px] font-medium leading-[20px]">{score}</span>
      <span className=" text-[12px] font-normal leading-[18px]">
        ({gatewayScoreDesc})
      </span>
    </div>
  );
};
